import { Classes, H2, Icon, Tooltip } from "@blueprintjs/core";
import { IconName, IconNames } from "@blueprintjs/icons";
import classNames from "classnames";
import { FieldLabel } from "components/common/FieldLabel";
import { Surface } from "components/common/Surface";
import { Loading } from "types/loadingType";
import css from "./MetricCard.module.scss";

interface RichMetricCardProps {
    icon: IconName;
    label: string;
    value: Loading<string>;
    /** Sits on the value's baseline, for a unit or a qualifier. */
    valueSuffix?: string;
    description: string;
    /** Long-form explanation, behind an info icon in the top right corner. */
    tooltip?: string;
}

/** A metric on a bordered surface, with an icon on the label and a footnote. */
export const RichMetricCard: React.FC<RichMetricCardProps> = ({
    icon,
    label,
    value,
    valueSuffix,
    description,
    tooltip
}) => (
    <Surface
        className={css["RichMetricCard"]}
        tone="white"
        radius="md"
        padding="small"
        bordered
    >
        <FieldLabel className={css["RichMetricCard-label"]}>
            <Icon
                icon={icon}
                size={12}
                className={css["RichMetricCard-icon"]}
            />
            {label}
            {tooltip !== undefined && (
                <Tooltip
                    className={css["RichMetricCard-tooltip-target"]}
                    content={tooltip}
                    compact
                    popoverClassName={css["RichMetricCard-tooltip-popover"]}
                >
                    <Icon
                        icon={IconNames.INFO_SIGN}
                        size={12}
                        className={css["RichMetricCard-tooltip-icon"]}
                    />
                </Tooltip>
            )}
        </FieldLabel>
        <div className={css["RichMetricCard-value-row"]}>
            <H2
                className={classNames(css["RichMetricCard-value"], {
                    [Classes.SKELETON]: value === "loading"
                })}
            >
                {value === "loading" ? "-" : value}
            </H2>
            {valueSuffix && (
                <span className={css["RichMetricCard-suffix"]}>
                    {valueSuffix}
                </span>
            )}
        </div>
        <span className={css["RichMetricCard-description"]}>{description}</span>
    </Surface>
);
